import { Empty } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import AllocationCharts from './Allocation';

const InvestmentAllocation: React.FC = () => {
    const allocations = useSelector((state: RootState) => state.deal.deal?.deal.fundDetails?.allocation);
    return (
        <div className="pb-4">
            <p className="text-[#142C53] text-2xl font-[WorkSans-Semibold] uppercase font-bold  my-1.5 common_read_title">
                Investment Allocation
            </p>
            <div className="flex flex-wrap pb-4 justify-center">
                {allocations?.allocationInPercent?.map((a, index) => (
                    <AllocationCharts
                        allocations={a.allocations || []}
                        type={a.type}
                        key={`${index}_allocation_${a.type}`}
                    />
                ))}
                {(!allocations?.allocationInPercent || allocations?.allocationInPercent?.length === 0) && (
                    <div className="flex justify-center items-center h-40">
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <p className="text-lg WorkSans font-semibold text-gray-500">No data available</p>
                            }
                        />
                    </div>
                )}
            </div>
            {allocations?.effectiveDate?.date && (
                <span className="text-xs">As of {allocations.effectiveDate.date}</span>
            )}
        </div>
    );
};

export default InvestmentAllocation;
